import { parseRpDetailsValue } from "./rpDetails.utils";

/**
 * Wait for rpDetails to be available in sessionStorage
 * @param {Object} options - Configuration options
 * @returns {Function} - Cleanup function to cancel waiting
 */
export const waitForRpDetails = (callback, options = {}) => {
  const { interval = 500, maxAttempts = 20 } = options;

  let attempts = 0;
  let intervalId = null;

  // Check immediately first
  const cookieValue = sessionStorage.getItem("cip_rpDetails");
  if (cookieValue) {
    const rpDetails = processRpDetailsData(cookieValue);
    if (rpDetails) {
      callback(rpDetails);
      return () => {}; // No cleanup needed
    }
  }

  intervalId = setInterval(() => {
    attempts++;

    const cookieValue = sessionStorage.getItem("cip_rpDetails");
    if (cookieValue) {
      const rpDetails = processRpDetailsData(cookieValue);
      if (rpDetails) {
        clearInterval(intervalId);
        callback(rpDetails);
      }
    } else if (attempts >= maxAttempts) {
      console.warn("rpDetails not available after timeout");
      clearInterval(intervalId);
    }
  }, interval);

  // Return cleanup function
  return () => {
    if (intervalId) {
      clearInterval(intervalId);
    }
  };
};

/**
 * Parse and process rpDetails data from sessionStorage
 * @param {string} cookieValue - Raw cookie value from sessionStorage
 * @returns {Object|null} - Parsed rpDetails or null
 */
const processRpDetailsData = (cookieValue) => {
  try {
    return parseRpDetailsValue(cookieValue);
  } catch (error) {
    console.error("Failed to parse cip_rpDetails:", error);
    return null;
  }
};

/**
 * Update UI elements with rpDetails
 * @param {Object} rpDetails - The rpDetails object
 */
const updateUIWithRpDetails = (rpDetails) => {
  if (!rpDetails) return;

  // Update logo link
  const logoLinkElement = document.getElementById("hfLifetechLogoLink");
  if (logoLinkElement && rpDetails?.logoLink) {
    logoLinkElement.href = rpDetails.logoLink;
  }

  // Update favicon if logoLink contains 'fisher'
  if (rpDetails?.logoLink?.includes("fisher")) {
    const link = document.querySelector("link[rel='icon']");
    if (link) {
      link.href = `${rpDetails.logoLink}/favicon.ico`;
    }
  }
};

/**
 * Initialize rpDetails - wait for it to be available and update UI
 * @returns {Function} - Cleanup function
 */
export const initializeRpDetails = () => {
  return waitForRpDetails((rpDetails) => {
    updateUIWithRpDetails(rpDetails);
  });
};
